export enum ListParameters {
    ListAlias = "ListAlias",
    ListType = "ListType",
    FieldFilterName = "FieldFilterName",
    HierarchyAttribute = "HierarchyAttribute"
}